/**
 * Full list: https://en.wikipedia.org/wiki/Date_format_by_country
 * Canada specific: https://en.wikipedia.org/wiki/Date_and_time_notation_in_Canada
 * South Africa specific: https://en.wikipedia.org/wiki/Date_and_time_notation_in_South_Africa
 */
export enum DateInputFormats {
  DMY = 'dd/MM/yyyy',
  MDY = 'M/d/yyyy',
  YMD = 'yyyy/MM/dd'
}

export enum DateInputPlaceholders {
  DMY = 'DD/MM/YYYY',
  MDY = 'MM/DD/YYYY',
  YMD = 'YYYY/MM/DD'
}

export enum DateInputParsings {
  DMY = 'dd/MM/yyyy',
  MDY = 'MM/dd/yyyy',
  YMD = 'yyyy/MM/dd'
}
